import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { fAuth } from "../config/firebase";
import { signOut } from "firebase/auth";
import { useAuthContext } from "../hooks/useAuth";

const ConfirmDelete = ({ onClose, confirmFunction }) => {
  // const [signOut] = useSignOut(fAuth);
  const navigate = useNavigate();

  return (
    <Modal show={true} onHide={() => { }}>
      <Modal.Header>
        <Modal.Title>Are you sure you want to delete ?</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          No
        </Button>
        <Button variant="danger" onClick={() => confirmFunction()}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDelete;
